import { ReactNode } from "react";
import { Link } from "react-router-dom";

const AuthLayout = ({
  children,
  title,
  subTitle,
  back,
}: {
  children: ReactNode;
  title: string;
  subTitle: string;
  back: boolean;
}) => {
  const Logo = require("../assets/logo.png");

  return (
    <div className="h-dvh w-full bg-[#FFFBFA]">
      <div className="max-w-[450px] p-3 mx-auto pt-[10vh]">
        {back && (
          <Link to="/" className="flex gap-3 mb-[50px] font-bold">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={2}
              stroke="currentColor"
              className="size-6"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M6.75 15.75 3 12m0 0 3.75-3.75M3 12h18"
              />
            </svg>
            <span>Back</span>
          </Link>
        )}

        <img
          src={Logo}
          alt="Logo"
          className="text-center mb-[43px] h-[50px] mx-auto"
        />
        <div className="text-center mb-[24px]">
          <p className="text-[35px] text-black font-bold">{title}</p>
          <span className="mt-[15px] text-ash">{subTitle}</span>
        </div>

        {children}
      </div>
    </div>
  );
};

export default AuthLayout;
